<template>
  <section class="SettingsAcc">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <Header :user="user" />
      <div class="col-md-12">
        <div v-if="alert.message">
          <div class="mt-4">
            <AlertError :msgError="alert.message" />
          </div>
        </div>
      </div>
      <component :is="SettingsTabComponent" ref="childView" :subscriptionData="this.subscriptionData"></component>
    </main>
    <Modal :name="'handlerErrorCallbackModal'" :size="'30'" :close="false" height="400px">
      <div class="p-3 text-center">
        <h3>Contact Support</h3>
        <h4 class="font-weight-bold my-2">{{ $t("lang.calendar.contact_with_support_team") }}</h4>
        <button class="btn btn-primary mr-2" @click="copyError">{{ $t("lang.label.copy") }}</button>
        <button class="btn btn-danger" @click="closeModal()">{{ $t("lang.button.close") }}</button>
      </div>
    </Modal>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Account from "@/components/Account/Account.vue";
import BlackList from "@/components/Account/BlackList.vue";
import ViewBilling from "@/components/Billing/ViewBilling.vue";
import AgencyData from "@/components/Agencies/AgencyData.vue";
import EmailSettings from "@/components/Account/EmailSettings.vue";
import ClientTeam from "@/components/Account/ClientTeam.vue";
import {
  billingsService,
  usersService,
  crmService,
  workspaceService,
  myCalendarService,
} from "@/_services";
import CustomFields from "@/components/Contacts/CustomFields.vue";
import Integrations from "@/components/Account/Integrations.vue";
import OliverSettings from "@/components/Account/OliverSettings.vue";
import ColdCallRules from "@/components/Account/ColdCallRules.vue";
import CampaignStepTemplateConfig from "@/components/Account/CampaignStepTemplateConfig.vue";
import AlertError from "@/components/AlertError.vue";
import Modal from "@/components/Common/Modal.vue";
import GeneralDataProtectionRegulation from "@/views/GeneralDataProtectionRegulation.vue";
import ClientDocs from "../components/Reports/ClientDocs.vue";
import AiAgentsPrompts from "@/views/AiAgentsPrompts.vue";
import { adminService } from "@/_services";

export default {
  data() {
    return {
      errorDetails: null,
    };
  },
  components: {
    Header,
    Account,
    ViewBilling,
    BlackList,
    AgencyData,
    EmailSettings,
    ClientTeam,
    CustomFields,
    Integrations,
    OliverSettings,
    ColdCallRules,
    CampaignStepTemplateConfig,
    GeneralDataProtectionRegulation,
    AlertError,
    Modal,
    AiAgentsPrompts,
    ClientDocs,
  },
  mounted() {
    window.onbeforeunload = null;
    this.udpdateHeader(this.$route.name);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      toSettingAccount: (state) => state.onboarding.toSettingAccount,
      currentUser: (state) => state.authentication.user,
      alert: (state) => state.alert,
    }),

    user() {
      return this.$store.state.authentication.user;
    },

    subscriptionData() {
      let recurring_payment_period = 1;
      if (this.$route.query.annual == 1) {
        recurring_payment_period = 12;
      }
      return {
        plan_id: this.$route.query.plan_id,
        recurring_payment_period: recurring_payment_period,
      };
    },

    SettingsTabComponent() {
      //If this component is called from Onboarding -> complete your profile
      if (this.toSettingAccount) {
        this.goToSettingAccount(false);
        this.changeHeaderTab({ tab: "ACCOUNT" });
        return "account";
      }
      if (this.headerTab === "ACCOUNT") {
        return "account";
      } else if (this.headerTab === "AGENCYDATA") {
        return "AgencyData";
      } else if (this.headerTab === "EMAILSETTINGS") {
        return "EmailSettings";
      } else if (this.headerTab === "TEAM") {
        return "ClientTeam";
      } else if (this.headerTab === "CUSTOMFIELDS") {
        return "CustomFields";
      } else if (this.headerTab === "INTEGRATIONS") {
        return "Integrations";
      } else if (this.headerTab === "OLIVERSETTINGS") {
        return "OliverSettings";
      } else if (this.headerTab === "CAMPAIGNSTEPTEMPLATE") {
        return "CampaignStepTemplateConfig";
      } else if (this.headerTab === "BLACKLIST") {
        return "BlackList";
      } else if (this.headerTab === "rgpd") {
        return "GeneralDataProtectionRegulation";
      } else if(this.headerTab === "IA_PROMPS"){
        return "AiAgentsPrompts";
      } else if(this.headerTab === "DOCUMENTS"){
        return "ClientDocs";
      }else if (this.headerTab === "BILLING") {
        return "ViewBilling";
      } else if (this.headerTab === "COLDCALLRULES") {
        return "ColdCallRules";
      } else {
        if (this.hasPermissions("adminClients")) {
          this.changeHeaderTab({ tab: "ACCOUNT" });
          return "account";
        }
        if (this.user.is_agency == 1 && this.user.role_id == 3) {
          this.changeHeaderTab({ tab: "EMAILSETTINGS" });
          return "EmailSettings";
        }
        if (this.hasPermissions("billing") || this.isBdrUser()) {
          this.changeHeaderTab({ tab: "ACCOUNT" });
          return "account";
        }
        this.changeHeaderTab({ tab: "BILLING" });
        return "ViewBilling";
      }
    },
  },
  created() {
    this.$store.dispatch("alert/clear");
    this.getAllOptionsList();
    // console.log(this.$route.query.scope)
    if (
      this.$route.query.scope &&
      this.$route.query.scope.includes(
        "https://www.googleapis.com/auth/siteverification"
      )
    ) {
      workspaceService
        .updateWorkspaceToken(this.$route.query.code)
        .then((result) => {
          this.$router.push("/");
        });
    } else {
      console.log("entre aca");
      if (this.$route.params.section === undefined && this.$route.query.code) {
        let code = this.$route.query.code;
        adminService.sendCodeGoogle(code).then((res) => {
          console.log(res);


          if (res.result == "NOTSCOPES") {
            myCalendarService.deleteAgenda();
            this.$swal({
              type: "error",
              title: "ERROR",
              text: this.$t("lang.calendar.error_scopes"),
              showConfirmButton: false,
              timer: 2000,
            });
          } 
          else if(res.result == "User not found"){
            console.log("ok");
            this.$router.replace({ query: {} });
            this.$swal({
              type: "error",
              title: "ERROR",
              text: `your account sync(${res.email_sync}) is not the same as your registered account in Oliverlist: ${res.email_oliver} `,
              showConfirmButton: true,
              timer: 12000,
            });
            return false;
          }
          else {
            if (res.error) {
              console.log(res);
              this.errorDetails = res.error.message;
              this.$modal.show("handlerErrorCallbackModal");
            } else if (res.warning == "ms_personal_account") {
              this.$swal({
                type: "warning",
                title: "Microsoft",
                text: this.$t("lang.appointments.ms_personal_account"),
                showConfirmButton: true,
              });
            } else {
              this.$swal({
                type: "success",
                title: "success",
                text: "account synced successfully",
                showConfirmButton: false,
                timer: 2000,
              });
            }


          }
        })
        .catch((err) => {
          console.log("error del handler", err);
          this.errorDetails = err.error.message;
          this.$modal.show("handlerErrorCallbackModal");
        });
        return;
      }
    }
    if (
      typeof this.$route.params.section === "undefined" &&
      this.$route.query.code &&
      this.$route.query.state
    ) {
      usersService
        .verificationAuthenticationCode(
          this.$route.query.code,
          this.$route.query.state
        )
        .then(
          (result) => {
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return true;
          },
          (error) => {
            this.$store.dispatch(
              "alert/newError",
              { message: error, section: "emailsettings" },
              { root: true }
            );
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return true;
          }
        );
    }
    if (this.$route.query.synchronisation) {
      this.changeHeaderTab({ tab: "EMAILSETTINGS" });
      return true;
    }
    if (this.$route.query.blacklist) {
      this.changeHeaderTab({ tab: "BLACKLIST" });
      return true;
    }

    if (this.$route.query.mycustomfields) {
      this.changeHeaderTab({ tab: "CUSTOMFIELDS" });
      return true;
    }

    if (this.$route.query.contractualdata) {
      window.location.href = "https://oliverlist.com/terms-of-services/";
      // this.changeHeaderTab({ tab: "AGENCYDATA" });
      // return true;
    }

    if (
      this.$route.query.billing ||
      this.$route.query.profile ||
      this.$route.query.invoices
    ) {
      this.changeHeaderTab({ tab: "PAYMENT" });
      return true;
    }

    if (this.$route.query.integrations) {
      this.changeHeaderTab({ tab: "INTEGRATIONS" });
      return true;
    }

    if (this.$route.query.rgpd == "1") {
      this.changeHeaderTab({ tab: "rgpd" });
      return true;
    }

    if (this.$route.query.IA_PROMPS == "1") {
      this.changeHeaderTab({ tab: "IA_PROMPS" });
      return true;
    }

    if (
      this.$route.query.email &&
      this.$route.query.grant_id &&
      this.$route.query.provider
    ) {
      if (true || this.$route.query.success === "true") {
        let data = {
          email: this.$route.query.email,
          grant_id: this.$route.query.grant_id,
          provider: this.$route.query.provider,
          success: this.$route.query.success,
        };
        usersService.setNylasIntegration(data).then(
          (result) => {
            let type = result;
            let title = this.$t("lang.label.great");
            let message = this.$t("lang.integrations." + result);
            this.$swal({
              type: type,
              title: title,
              text: message,
              showConfirmButton: false,
              timer: 8000,
            });
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return;
          },
          (error) => {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
          }
        );
      }
    }

    if (this.user.is_agency != 1 && this.user.is_sales == 1) {
      this.changeHeaderTab({ tab: "EMAILSETTINGS" });
      return true;
    }

    if (typeof this.$route.params.section !== "undefined") {
      if (this.$route.params.section == "payment") {
        let ingenicoResponse = null;
        if (this.$route.params.type == "viva") {
          ingenicoResponse = this.$route.query;
        } else {
          ingenicoResponse = {
            id: this.$route.params.type,
            ncerror: this.$route.query.NCERROR,
            ingenico_status: this.$route.query.STATUS,
          };
        }
        billingsService
          .confirmPaymentMethod(ingenicoResponse)
          .then((result) => {
            let type = result;
            let title = this.$t("lang.label.great");
            let message = this.$t("lang.paymentmethod." + result);
            if (result == "error") {
              title = this.$t("lang.label.error");
            }
            this.$swal({
              type: type,
              title: title,
              text: message,
              showConfirmButton: true,
            }).then((result) => {
              const { dispatch } = this.$store;
              dispatch("authentication/refreshToken").then((result) => {
                if (type == "error") {
                  const conditionPayment = "error";
                  this.$router.push({
                    path: "/dashboard",
                    query: { conditionPayment },
                  });
                } else {
                  const conditionPayment = "ok";
                  this.$router.push({
                    path: "/dashboard",
                    query: { conditionPayment },
                  });
                  //this.$router.push("/dashboard");
                }
              });
            });
          });
      } else if (this.$route.params.section == "integrations") {
        console.log("entro en integra");
        if (this.$route.params.type !== undefined) {
          crmService
            .authorize(this.$route.query.code, this.$route.params.type)
            .then(
              (result) => {
                let type = result;
                let title = this.$t("lang.label.great");
                let message = this.$t("lang.integrations." + result);
                this.$swal({
                  type: type,
                  title: title,
                  text: message,
                  showConfirmButton: false,
                  timer: 8000,
                });
                this.changeHeaderTab({ tab: "INTEGRATIONS" });
              },
              (error) => {
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  text: this.$t("lang.label.error"),
                  showConfirmButton: true,
                });
                this.changeHeaderTab({ tab: "INTEGRATIONS" });
              }
            );
        }
      } else {
        this.changeHeaderTab({});
      }
    } else {
      this.changeHeaderTab({});
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("optionsList", {
      getAllOptionsList: "getAll",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    ...mapActions("onboarding", {
      goToSettingAccount: "goToSettingAccount",
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    isBdrUser() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2)
    },
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    closeModal(){
      this.$modal.hide("handlerErrorCallbackModal");
    },
    async copyError() {
      if (!this.errorDetails) {
        console.log("No hay error para copiar");
        return;
      }

      // 🔹 Intento moderno
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(this.errorDetails);
          return;
        } catch (err) {
          console.log("Clipboard API falló, usando fallback...", err);
        }
      }

      // 🔹 Fallback clásico (funciona casi siempre)
      try {
        const textarea = document.createElement("textarea");
        textarea.value = this.errorDetails;

        // evitar que se vea el textarea
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        document.execCommand("copy");
        document.body.removeChild(textarea);
      } catch (err) {
        console.log("No se pudo copiar:", err);
      }
    }
  },
};
</script>
<style>
.SettingsAcc .header {
  margin-left: 0px;
}

section.SettingsAcc {
  overflow-x: hidden;
}
</style>
